import { render, staticRenderFns } from "./OwnerEditor.vue?vue&type=template&id=4940c389&"
import script from "./OwnerEditor.vue?vue&type=script&lang=js&"
export * from "./OwnerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports